import { ProjectType } from "../Types/ProjectType";

export const addProject = (projectCount) => {
  return {
    type: ProjectType.PROJECTCOUNT,
    payload: projectCount,
  };
};
